import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_GRAPHQL_RESOLVER_TRACING = defineFcm('graphql_resolver_tracing')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				sampling: {
					type: 'number',
				},
				list: {
					type: 'array',
					optional: true,
					shape: {
						type: 'object',
						shape: {
							operationName: {
								type: 'string',
								optional: true,
							},
							field: {
								type: 'string',
							},
						},
					},
				},
			},
		}),
	)
	.withDefault({
		sampling: 0,
		list: undefined,
	})
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'GQL middle-end layer',
		description: `Used to register some resolvers for tracing within the logs.

	This will result in some resolvers' durations being logged to the logs.

	The sampling rate is defined at the root level. It should be a number between 0 and 1. If the sampling rate is 0.01, 1% of the users' resolver calls will be traced.

	For each item in the list:
	- "operationName" (optional) is the name of the operation as defined in the query/mutation on the client.
	- "field" is the name of the field being resolved (e.g. "Petition.supporterVoicesConnection" or "Query.petitionBySlugOrId"). Also supports globbing (e.g. "Petition.*" or "*.*" - uses minimatch under the hood).

	When tracing multiple resolvers, the sampling rate will be consistent, meaning that, within an operation, they will either all be sampled in, or none will.`,
		template: {
			sampling: 0.01,
			list: [
				{
					field: 'Petition.supporterVoicesConnection',
				},
				{
					operationName: 'PetitionDetails',
					field: 'Petition.updatesConnection',
				},
			],
		},
	});
